module.exports = __webpack_public_path__ + "static/interior-exterior-cladding-45adc4de8e222289e60897c8ebffe81a.jpg";